var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGtkDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#242938",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E40000",
    stroke: "#fff",
    strokeWidth: 4.919,
    d: "M30.8746 169.163L26 52.0615L103.923 108.268V234.745L30.8746 169.163Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7FE719",
    stroke: "#fff",
    strokeWidth: 4.919,
    d: "M103.946 234.767L220.842 187.936L230.592 70.835L103.946 108.314V234.79V234.767Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#729FCF",
    stroke: "#fff",
    strokeWidth: 4.919,
    d: "M26 52.0616L103.923 108.268L230.568 70.7896L143.606 21L26 52.0616Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2.901,
    d: "M143.227 135.325V21.5461M143.227 135.325L31.3005 167.183L143.227 135.325ZM143.227 135.325L221.316 187.663L143.227 135.325Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtkDark);
export default __webpack_public_path__ + "static/media/GTK-Dark.5d9fa9726aa6d9fb7b7f876d607f8b2f.svg";
export { ForwardRef as ReactComponent };